<div class="is-relative">
    <a
        class="has-text-black close-button"
        (click)="closeForm()"
        ><i class="fas fa-times"></i
    ></a>
</div>
<div
    *ngIf="loading && !error"
    class="dialog-loading-spinner"
>
    <mat-spinner [diameter]="28"></mat-spinner>
</div>
<div
    *ngIf="error"
    class="dialog-error-message"
>
    Error Loading {{ title }}
</div>
<div
    class="content-wrapper"
    [hidden]="loading || error"
>
    <ng-content></ng-content>
</div>
